export default __webpack_public_path__ + "static/media/29-JustSantorini.8df5581c.jpeg";